import { isSpiderClient } from "@/utils/isSpider";
import { TabShared } from "@/utils/tabShared";
import { useEffect, useRef } from "react";
import useAppStore from "./store";

export function useTabShare() {
  const tabShareRef = useRef();

  // 同步tabShare过来的数据（其他tab更新的数据）
  useEffect(() => {
    const sharedWorkerHref = useAppStore.getState().config?.sharedWorkerHref;

    if (isSpiderClient() || navigator.userAgent.includes("HeadlessChrome")) {
      return;
    }

    const tabShared = (tabShareRef.current = new TabShared({
      sharedWorkerHref,
    }));

    const removeListen = tabShared.onSyncData((data) => {
      if (typeof data !== "object" || Array.isArray(data)) {
        console.warn("data 需要是一个对象");
        return;
      }

      const nextStore = {};
      for (const key in data) {
        nextStore[key] = data[key].value;
      }

      // 空对象不做操作
      if (Object.keys(nextStore).length === 0) return;

      // 更新数据， 第三个参数是跳过set的hook，避免循环更新
      useAppStore.setState(nextStore, false, true);
    });

    return () => {
      removeListen();
    };
  }, []);

  // 将store数据更新到tabShare
  useEffect(() => {
    const tabShareConfig = useAppStore.getState().config?.tabShare || [];

    if (tabShareConfig?.length === 0) return;

    // 监听状态变化
    tabShareConfig.forEach((share) => {
      useAppStore.afterSet((nextState) => {
        if (nextState.hasOwnProperty(share.key)) {
          tabShareRef.current?.updateData({
            [share.key]: { value: nextState[share.key], time: Date.now() },
          });
        }
      });
    });
  }, []);

  const getTabShareData = async () => {
    const tabShareConfig = useAppStore.getState().config?.tabShare || [];

    if (tabShareConfig?.length === 0 || !tabShareRef.current) return {};

    const data = await tabShareRef.current?.getSharedStore();

    const syncStore = {};
    tabShareConfig.forEach((share) => {
      if (!data[share.key]) {
        return;
      }

      // 判断时间有效期
      if (Date.now() - data[share.key].time < share.time * 1000) {
        syncStore[share.key] = data[share.key].value;
      }
    });

    return syncStore;
  };

  /**
   * 获取dmUnread的更新时间
   * @returns 更新时间
   */
  const getShareUpdateTime = async () => {
    const data = await tabShareRef.current?.getSharedStore();
    return data?.dmUnread?.time;
  };

  return {
    getTabShareData,
    getShareUpdateTime,
  };
}
